import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type {
  PolicyProposal,
  PolicyChangeProposal,
} from '@mls-wallet/shared-types';

// Result of processing a single policy change within a batch proposal
type PolicyChangeResult =
  | { index: number; success: true }
  | { index: number; success: false; error: string };

// Response from the create policy proposal API endpoint
type CreatePolicyProposalResponse = {
  success: boolean;
  proposal: PolicyProposal | null;
  results: PolicyChangeResult[];
};

// Input type for creating a proposal
type CreatePolicyProposalInput = {
  policyChangeProposals: PolicyChangeProposal[];
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreatePolicyProposalInput }
): Promise<CreatePolicyProposalResponse> => {
  // Org context comes from x-current-org-id cookie (not URL params)
  const url = `admin/policy/proposals`;
  return await denApi.post<
    CreatePolicyProposalResponse,
    CreatePolicyProposalInput
  >(url, arg);
};

export function useCreatePolicyProposal(
  swrOptions?: SWRMutationConfiguration<
    CreatePolicyProposalResponse,
    Error,
    string,
    CreatePolicyProposalInput
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    CreatePolicyProposalResponse,
    Error,
    string,
    CreatePolicyProposalInput
  >('admin/policy/proposals', fetcher, swrOptions);

  return { createProposal: trigger, isLoading: isMutating, error };
}
